window.phoneFormatter = function(value, row) {
    let html = '';
    if (value) {
        html += '<a href="tel:'+value+'" rel="nofollow">'+value+'</a>';
    }
    return html;
};
